export const getAllTabDATA = {
	summary: '每日更新，投资知识+每日市场解读，掌握更多资讯，投资更有把握',
	subjectVoList: [
		{
			topicKey: '热点',
			topicAliasName: '热点',
			detailType: 2,
			id: 2710472,
		},
		{
			topicKey: '宏观大势',
			topicAliasName: '宏观',
			detailType: 2,
			id: 2710357,
		},
		{
			topicKey: '基金学堂',
			topicAliasName: '基金学堂',
			detailType: 2,
			id: 2710359,
		},
		{
			topicKey: '更多资讯',
			topicAliasName: '更多内容',
			detailType: 2,
			id: 2710363,
		},
	],
	sceneCollName: '财富投研中心',
	backgroundImgUrl:
		'https://img12.360buyimg.com/jrpmobile/jfs/t1/221987/2/22954/6050/640192cdFeeb4e4b7/c48ea1fe407a10b8.png',
};
